<template>
  <div class="app-container">
    <!-- 主要内容区域 -->

    <div class="main-content">
      <el-carousel trigger="click" :height="carouselHeight" style="width: 100%">
        <el-carousel-item v-for="(item, i) in carousellist" :key="i">
          <img
            style="width: 100%; height: 100%; object-fit: cover; display: block;"
            :src="item.pictureUrl"
            alt=""
            @click="carouselink(item)"
          />
        </el-carousel-item>
      </el-carousel>

      <div class="classification" v-if="classlist && classlist.length > 0">
        <div class="course-card" v-for="(item, i) in classlist" :key="i" @click="classlink(item)">
          <div class="card-content" :style="item.src ? { backgroundImage: `url(${item.src})` } : {}">
          </div>
        </div>
      </div>

      <!-- 公开课 -->

      <div class="openClass">
        <div class="title">海量高品质公开课</div>
        <div class="classCard">
          <div
            class="card"
            v-for="(item, i) in mcard"
            :key="i"
            @click="handelopenclass(item)"
          >
            <img :src="item.coverUrl" alt="" />

            <div style="padding: 20px">
              <p>{{ item.name }}</p>

              <p style="color: red">{{ item.fee ? '￥' + item.fee : '免费' }}</p>

              <!-- <el-divider style="margin:10px"></el-divider> -->

              <div
                style="
                  display: block;

                  width: 100%;

                  margin: 10px 0;

                  border: 1px solid #dde2ee;
                "
              ></div>

              <div class="perinfo">
                <img class="headimg" :src="item.teacherAvatars && item.teacherAvatars[0] ? item.teacherAvatars[0] : ''" alt="" />

                <span>{{ item.teacherNames && item.teacherNames[0] ? item.teacherNames[0] : '讲师' }}</span>
              </div>
            </div>
          </div>

        </div>

        <!-- <img
          class="more"
          src="https://www.hketang.cn/_nuxt/img/more-btn.b21b475.png"
          alt=""
          @click="morelink"
        /> -->
      </div>

      <!-- 编程学院 -->

      <div class="course">
        <div class="title">编程学院</div>

        <div class="classCard">
          <div class="card" v-for="(item, i) in bcard" :key="i" @click="handelopenclass(item)">
            <img :src="item.coverUrl" alt="" />

            <div style="padding: 20px">
              <p>{{ item.name }}</p>

              <p style="color: red">
                ￥<span style="font-size: 26px; margin-left: 5px; font-weight: 700">{{
                  item.fee
                }}</span>
              </p>

              <!-- <el-divider style="margin:10px"></el-divider> -->

              <div
                style="
                  display: block;

                  width: 100%;

                  margin: 10px 0;

                  border: 1px solid #dde2ee;
                "
              ></div>

              <div class="perinfo">
                <img class="headimg" :src="item.teacherAvatars && item.teacherAvatars[0] ? item.teacherAvatars[0] : ''" alt="" />

                <span>{{ item.teacherNames && item.teacherNames[0] ? item.teacherNames[0] : '讲师' }}</span>
              </div>
            </div>
          </div>

        </div>
      </div>

      <!-- 精品会员课 -->

      <div class="course">
        <div class="title">精品会员课</div>

        <div class="classCard">
          <div class="card" v-for="(item, i) in vipcard" :key="i" @click="handelopenclass(item)">
            <img :src="item.coverUrl" alt="" />

            <div style="padding: 20px">
              <p>{{ item.name }}</p>

              <p style="color: red">
                ￥<span style="font-size: 26px; margin-left: 5px; font-weight: 700">{{
                  item.fee
                }}</span>
              </p>

              <!-- <el-divider style="margin:10px"></el-divider> -->

              <div
                style="
                  display: block;

                  width: 100%;

                  margin: 10px 0;

                  border: 1px solid #dde2ee;
                "
              ></div>

              <div class="perinfo">
                <img class="headimg" :src="item.teacherAvatars && item.teacherAvatars[0] ? item.teacherAvatars[0] : ''" alt="" />

                <span>{{ item.teacherNames && item.teacherNames[0] ? item.teacherNames[0] : '讲师' }}</span>
              </div>
            </div>
          </div>

        </div>

        <!-- <img
          class="more"
          src="https://www.hketang.cn/_nuxt/img/more-btn.b21b475.png"
          alt=""
          @click="morelink"
        /> -->
      </div>

      <!-- 师资团队 -->

      <div class="team-box">
        <div class="title">师资团队</div>

        <div class="p">
          直面一线的实战高手，言传身教的倾囊相授，讲授最前沿的设计思维与理念
        </div>

        <vue3-seamless-scroll
          :list="teamlist"
          :step="1"
          :limitScrollNum="2"
          direction="left"
          :hover="true"
          class="carouselImage"
        >
          <ul class="ul-item">
            <li class="li-item" v-for="(item, index) in teamlist" :key="index">
              <img :src="item.avatar" alt="" class="team-img" />

              <div class="info">
                <div class="name">{{ item.name }}</div>

                <div class="introduce">{{ item.introInfo }}</div>
              </div>

              <div class="absolute">
                <div class="absolutename">{{ item.name }}</div>

                <div class="absolutetitle">讲师介绍</div>

                <div class="absoluteInfo">
                  {{ item.introDetail }}
                </div>
              </div>
            </li>
          </ul>
        </vue3-seamless-scroll>
      </div>

      <!-- 学员作品 -->

      <div class="works-box">
        <div class="title-box">
          <div class="title">学员作品</div>
          <el-button
            class="title-btn"
            @click="changeworks('1')"
            :class="worksactive == '1' ? 'worksactive' : ''"
            >平面设计</el-button
          >
          <el-button
            class="title-btn"
            @click="changeworks('2')"
            :class="worksactive == '2' ? 'worksactive' : ''"
            >插画设计</el-button
          >
        </div>
        <div class="list-box">
          <div class="card" v-for="(item, i) in workslist" :key="i" @click="handledetal(item)">
            <img :src="item.pictureUrl" alt="" />
            <div class="info-box">
              <div class="name">{{ item.title }}</div>
              <div class="type">{{ item.studentName || '未知学员' }}</div>
              <div class="date">{{ item.className || '未知班级' }}</div>
            </div>
          </div>
        </div>
      </div>
      <indetails
        :dialogTableVisible.sync="dialogTableVisible"
        :id="selectedId"
      ></indetails>
    </div>
  </div>
</template>

<script>
import { Vue3SeamlessScroll } from "vue3-seamless-scroll";
import {
  getHomeData,
  getbanner,
  getcoursetype,
  courseinfo,
  getteachers,
  getnews,
  getworks
} from "@/api/index";
import indetails from "../production/details.vue";
export default {
  name: "home",
  components: {
    Vue3SeamlessScroll,
    indetails
  },
  data() {
    return {
      carouselHeight: "500px",
      carousellist: [],
      classlist: [],
      mcard: [],
      bcard: [],
      vipcard: [],
      teamlist: [],
      worksactive: "0",

      workslist: [],
      // 新增：声明作品数据的两个分类，确保响应式
      worksDesignList: [],
      worksIllustrationList: [],
      newslist: [],
      dialogTableVisible: false,
      selectedId: null,
    };
  },
  created() {
    // 使用聚合接口获取首页数据
    this.loadHomeData();
    // 注意：作品数据已包含在聚合接口中（默认平面设计与插画设计），无需单独调用
  },
  mounted() {
    this.updateCarouselHeight();
    window.addEventListener("resize", this.updateCarouselHeight);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.updateCarouselHeight);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateCarouselHeight);
  },
  methods: {
    updateCarouselHeight() {
      const w = window.innerWidth;
      if (w <= 600) {
        this.carouselHeight = Math.round(w * 0.52) + "px";
      } else if (w <= 992) {
        this.carouselHeight = Math.round(w * 0.38) + "px";
      } else {
        this.carouselHeight = "500px";
      }
    },
    // 加载首页聚合数据
    loadHomeData() {
      getHomeData().then((res) => {
        if (res.data) {
          const homeData = res.data;
          
          // 设置轮播图数据
          if (homeData.bannerList) {
            this.carousellist = homeData.bannerList;
          }
          
          // 设置课程类型数据
          if (homeData.courseTypeList && homeData.courseTypeList.length > 0) {
            this.classlist = homeData.courseTypeList.map(item => ({
              src: item.imageUrl,
              title: item.name || '未知分类',
              type: item.id ? item.id.toString() : '',
              id: item.id
            }));
          }
          
          // 设置公开课数据
          if (homeData.publicCourseList) {
            this.mcard = homeData.publicCourseList;
          }
          
          // 设置编程学院课程数据
          if (homeData.programmingCourseList) {
            this.bcard = homeData.programmingCourseList;
          }
          
          // 设置进阶课程数据
          if (homeData.advancedCourseList) {
            this.vipcard = homeData.advancedCourseList;
          }
          
          // 设置教师数据
          if (homeData.teacherList) {
            this.teamlist = homeData.teacherList;
          }
          
          // 设置新闻数据
          if (homeData.newsList) {
            this.newslist = homeData.newsList;
          }
          
          // 设置作品数据（平面设计与插画设计）
          if (homeData.worksDesignList) {
            this.worksDesignList = homeData.worksDesignList;
          }
          if (homeData.worksIllustrationList) {
            this.worksIllustrationList = homeData.worksIllustrationList;
          }
          // 默认选中平面设计并渲染
          this.worksactive = "1";
          this.workslist = this.worksDesignList;
        }
      }).catch(error => {
        console.error('获取首页数据失败:', error);
        // 如果聚合接口失败，回退到原来的多接口调用方式
        this.loadHomeDataFallback();
      });
    },

    // 回退方案：使用原来的多接口调用
    loadHomeDataFallback() {
      // 获取banner
      getbanner({
        pageNo: 1,
        pageSize: 10,
        suatus: true
      }).then((res) => {
        if (res.data && res.data.list) {
          this.carousellist = res.data.list;
        }
      });

      // 获取课程类型
      getcoursetype().then((res) => {
        if (res.data && res.data.length > 0) {
          this.classlist = res.data.map(item => ({
            src: item.imageUrl,
            title: item.name || '未知分类',
            type: item.id ? item.id.toString() : '',
            id: item.id
          }));
        }
      });

      // 获取各类课程数据
      courseinfo({ pageNo: "1", pageSize: "4", typeId: "2" }).then((res) => {
        if (res.data && res.data.list) this.mcard = res.data.list;
      });
      courseinfo({ pageNo: "1", pageSize: "4", typeId: "1" }).then((res) => {
        if (res.data && res.data.list) this.bcard = res.data.list;
      });
      courseinfo({ pageNo: "1", pageSize: "8", typeId: "3" }).then((res) => {
        if (res.data && res.data.list) this.vipcard = res.data.list;
      });

      // 获取教师数据
      getteachers({ pageNo: "1", pageSize: "100", homePageViewd: true }).then((res) => {
        if (res.data && res.data.list) this.teamlist = res.data.list;
      });

      // 获取新闻数据
      getnews({ pageNo: "1", pageSize: "3" }).then((res) => {
        if (res.data && res.data.list) this.newslist = res.data.list;
      });

      // 获取作品数据（平面设计与插画设计）
      getworks({ pageNo: "1", pageSize: "4", worksType: "1" }).then((res) => {
        if (res.data && res.data.list) {
          this.worksDesignList = res.data.list;
          // 默认渲染平面设计
          this.worksactive = "1";
          this.workslist = this.worksDesignList;
        }
      });
      getworks({ pageNo: "1", pageSize: "4", worksType: "2" }).then((res) => {
        if (res.data && res.data.list) {
          this.worksIllustrationList = res.data.list;
        }
      });
    },

    morelink() {
      this.$store.commit("classtype", "1");
      this.$store.commit("activeNavIndex", 1);
      this.$router.push({ path: "/course" }).catch(err => {
        if (err.name !== 'NavigationDuplicated') {
          console.error('路由跳转错误:', err);
        }
      });
    },
    changeworks(val) {
      this.worksactive = val;
      this.workslist = val === "1" ? this.worksDesignList : this.worksIllustrationList;
    },
    // 恢复：轮播图点击跳转
    carouselink(val) {
      if (val.linkUrl) {
        let linkurl = val.linkUrl;
        // 如果链接不包含协议，则添加https://
        if (!linkurl.startsWith('http://') && !linkurl.startsWith('https://')) {
          linkurl = 'https://' + linkurl;
        }
        window.open(linkurl, '_blank');
      }
    },
    classlink(val) {
      const tabTypeMap = {
        编程学院: 1,
        公开课: 2,
        进阶课: 3,
        专项课: 4,
        综合课: 5
      };
      const numericType = Number(val.type || val.id);
      const nextType = [1, 2, 3, 4, 5].includes(numericType)
        ? numericType
        : (tabTypeMap[val.title] || 1);
      this.$store.commit("classtype", nextType);
      this.$store.commit("activeNavIndex", 1);
      this.$router.push({ path: "/course" }).catch(err => {
        if (err.name !== 'NavigationDuplicated') {
          console.error('路由跳转错误:', err);
        }
      });
    },
    handelopenclass(val) {
      this.$store.commit("activeNavIndex", 1);
      this.$router.push({ path: "/coursedetals",query: { id: val.id } }).catch(err => {
        if (err.name !== 'NavigationDuplicated') {
          console.error('路由跳转错误:', err);
        }
      });
    },
    handledetal(val) {
      this.selectedId = val.id;
      this.dialogTableVisible = true;
    },
    handlenewsdetal(item) {
      this.$router.push({ path: "/newsdetals", query: { id: item.id } }).catch(err => {
        if (err.name !== 'NavigationDuplicated') {
          console.error('路由跳转错误:', err);
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.app-container {
  padding: 0;
  margin: 0;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei", Arial, sans-serif;
  color: #333;
  overflow: hidden;
  clear: both;

  /* 团队列表样式 */
  .team-box {
    .ul-item {
      .li-item {
        position: relative;
        overflow: hidden;

        .info {
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          background-color: rgba(0, 0, 0, 0.7);
          color: white;
          padding: 10px;
          transition: transform 0.3s ease-in-out;
        }

        &:hover .info {
          transform: translateY(100%);
        }
      }
    }
  }

  /* 顶部服务栏样式 */
  .top-service-bar {
    border: 1px;
    padding: 10px 20px;
    text-align: right;
    color: #666;
    display: flex;
    margin: 0 auto;
    justify-content: space-around;
    align-items: center;
    width: 900px;
    height: 70px;
    clear: both;

    .img {
      width: 80px;
      height: 70px;
    }

    span {
      font-size: 16px;
      color: black;
    }
  }

  .button {
    cursor: pointer;
    border: none;
    font-size: 21px;
  }

  /* 导航菜单样式 */
  .navigation-menu {
    margin: 20px auto;
    width: 700px;
    display: flex;
    align-items: center;
    justify-content: space-around;
    font-size: 18px;
    clear: both;

    span {
      cursor: pointer;
    }

    .nvaActive {
      color: red;
    }
  }

  /* 主要内容区域样式 */
  .main-content {
    margin: 0 auto;
    clear: both;
  }

  .classification {
    clear: both;
    display: flex;
    justify-content: center;
    gap: 20px;
    width: 1500px;
    margin: 30px auto;
    padding: 20px 0;

    .course-card {
      cursor: pointer;
      transition: transform 0.3s ease;
      border-radius: 15px;
      overflow: hidden;

      &:hover {
        transform: translateY(-5px);
        box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
      }

      .card-content {
        width: 223px;
        height: 89px;
        border-radius: 12px;
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        background-color: #f5f5f5;
      }
    }
  }

  .openClass {
    overflow: hidden;
    padding: 40px 0;
    clear: both;
    width: 100%;
    background-color: #e6eaed;

    .title {
      font-size: 36px;
      color: #2d3341;
      font-weight: 700;
      font-family: "Microsoft YaHei";
      line-height: 1.1;
    }

    .more {
      cursor: pointer;
      width: 354px;
      height: 56px;
      margin-top: 20px;
    }

    h1 {
      clear: both;
      margin: 0;
    }

    .classCard {
      margin: auto;
      width: 1200px;
      display: flex;
      align-items: stretch;
      justify-content: flex-start;
      flex-wrap: wrap;
      gap: 24px 17px;

      .card {
        clear: both;
        width: 287px;
        height: 354px;
        background-color: #fff;
        border-radius: 10px;
        overflow: hidden;
        margin: 24px 0 0;
        box-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);
        cursor: pointer;
        transition: all 0.3s ease;
        &:hover {
          transform: translateY(-5px);
          box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
        }
        img {
          width: 287px;
          height: 185px;
          object-fit: cover;
        }

        p {
          font-size: 18px;
          width: 263px;
          margin: auto;
          text-align: left;
          margin-bottom: 10px;
        }

        .perinfo {
          display: flex;
          align-items: center;
          color: #838a9d;

          .headimg {
            width: 44px;
            height: 44px;
            border-radius: 50%;
            margin-right: 10px;
          }

          span {
            font-size: 14px;
          }
        }
      }
    }
  }

  .course {
    overflow: hidden;
    padding: 40px 0;
    clear: both;
    width: 100%;

    .title {
      font-size: 36px;
      color: #2d3341;
      font-weight: 700;
      font-family: "Microsoft YaHei";
      line-height: 1.1;
    }

    h1 {
      clear: both;
      margin: 0;
    }

    .more {
      cursor: pointer;
      width: 354px;
      height: 56px;
      margin-top: 20px;
    }

    .classCard {
      margin: auto;
      width: 1200px;
      display: flex;
      align-items: stretch;
      justify-content: flex-start;
      flex-wrap: wrap;
      gap: 24px 17px;

      .card {
        clear: both;
        width: 287px;
        height: 354px;
        background-color: #fff;
        border-radius: 10px;
        overflow: hidden;
        margin: 24px 0 0;
        box-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);
        cursor: pointer;
        transition: all 0.3s ease;
        &:hover {
          transform: translateY(-5px);
          box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
        }
        img {
          width: 287px;
          height: 185px;
          object-fit: cover;
        }

        p {
          font-size: 18px;
          width: 263px;
          margin: auto;
          text-align: left;
          margin-bottom: 10px;
        }

        .perinfo {
          display: flex;
          align-items: center;
          color: #838a9d;

          .headimg {
            width: 44px;
            height: 44px;
            border-radius: 50%;
            margin-right: 10px;
          }

          span {
            font-size: 14px;
          }
        }
      }
    }
  }

  .team-box {
    background-color: #e6eaed;
    padding: 40px 0 80px;

    .title {
      font-size: 36px;
      color: #2d3341;
      font-weight: 700;
      font-family: "Microsoft YaHei";
      line-height: 1.1;
      margin-bottom: 24px;
    }

    .p {
      font-weight: 500;
      color: #838a9d;
      text-align: center;
      margin-bottom: 40px;
    }

    .carouselImage {
      margin: 45px auto;
      width: 1200px;
      overflow: hidden;
      margin: 0 auto;
      border: 1px solid #eee;
      position: relative;

      ul {
        list-style: none;
        padding: 0;
        margin: 0 auto;

        &.ul-item {
          display: flex;
          flex-wrap: nowrap;
          width: max-content;
          cursor: pointer;

          .li-item {
            flex-shrink: 0;
            width: 250px;
            height: 345px;
            margin: 0 25px 0 0;
            background-color: #fff;
            color: #fff;
            text-align: center;
            border-radius: 10px;
            position: relative;

            img {
              width: 250px;
              height: 345px;
              object-fit: cover;
            }

            .info {
              position: absolute;
              bottom: 0;
              width: 100%;
              height: 80px;
              background-color: #fff;
              display: flex;
              flex-direction: column;
              justify-content: center;
              padding: 0;
              box-sizing: border-box;

              .name {
                color: #000;
                font-size: 20px;
                font-weight: 600;
                line-height: 1.2;
              }

              .introduce {
                color: #ed8a42;
                font-size: 14px;
                margin-top: 8px;
                padding: 0 15px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              }
            }

            .absolute {
              display: none;
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              padding: 30px 20px;
              box-sizing: border-box;
              text-align: left;
              background-color: rgba(0, 0, 0, 0.6);
              font-family: Microsoft YaHei;

              .absolutename {
                color: #fff;
                font-size: 22px;
                font-weight: 700;
              }

              .absolutetitle {
                color: #fff;
                font-size: 16px;
                margin: 20px 0 10px;
                border-bottom: 1px solid rgba(255, 255, 255, 0.3);
                padding-bottom: 8px;
              }

              .absoluteInfo {
                color: #fff;
                font-size: 14px;
                line-height: 1.6;
                height: 180px;
                overflow-y: auto;
              }
              
              /* 自定义滚动条样式 */
              .absoluteInfo::-webkit-scrollbar {
                width: 4px;
              }
              .absoluteInfo::-webkit-scrollbar-thumb {
                background: rgba(255, 255, 255, 0.5);
                border-radius: 4px;
              }
            }

            &:hover .absolute {
              display: block;
            }
          }
        }
      }
    }
  }

  .works-box {
    text-align: left;
    width: 1200px;
    margin: 0 auto;
    padding: 58px 0 70px;
    .worksactive {
      background-color: #d5182f;
      color: #fff;
    }
    .title-box {
      font-family: "Microsoft YaHei";
      font-size: 36px;
      font-weight: 700;
      display: flex;
      align-items: center;

      .title {
        margin: 0 20px 0 0;
      }
      .title-btn {
        margin: 0 30px 0 0;
        font-weight: 400;
        font-size: 18px;
        font-family: "Microsoft YaHei";
        // color: #838a9d;
        border-radius: 10px;
        border: 2px solid #dde2ee;
      }
    }

    .list-box {
      display: flex;
      justify-content: space-between;
      margin: 40px 0 0 0;

      .card {
        width: 282px;
        border-radius: 10px;
        overflow: hidden;
        border: 1px solid #ebeef5;
        cursor: pointer;

        img {
          width: 282px;
          height: 160px;
          object-fit: cover;
        }

        .info-box {
          padding: 15px 10px;

          .name {
            font-size: 18px;
            font-family: "Microsoft YaHei";
            font-weight: 500;
            color: #2d3341;
            margin: 0 0 12px;
          }

          .type {
            font-size: 14px;
            color: #838a9d;
            margin: 0 0 20px;
            font-family: "Microsoft YaHei";
            font-weight: 400;
          }

          .date {
            text-align: right;
            font-size: 20px;
            color: #838a9d;
            font-weight: 400;
            font-family: "Microsoft YaHei";
          }
        }
      }

      &:hover .card {
        box-shadow: 0 0 10px #ebeef5;
      }
    }
  }

  .news-box {
    background-color: #e6eaed;
    padding: 40px 0;

    .nwes-title {
      font-size: 36px;
      font-family: "Microsoft YaHei";
      font-weight: 700;
      color: #2d3341;
      margin: 0 0 24px;
    }

    .nwes-card-box {
      width: 1200px;
      margin: 0 auto;
      display: flex;
      justify-content: flex-start;
      overflow: hidden;
      flex-wrap: wrap;
      gap: 24px;

      .nwes-card {
        width: 384px;
        height: 409px;
        background-color: #fff;
        border-radius: 10px;
        overflow: hidden;
        cursor: pointer;
        img {
          width: 384px;
          height: 252px;
          object-fit: cover;
        }

        .news-info-box {
          padding: 15px 10px 0 10px;

          .news-title {
            font-size: 18px;
            font-family: "Microsoft YaHei";
            font-weight: 500;
            margin: 0 0 12px;
            font-weight: 500;
            color: #2d3341;
            text-align: left;
          }

          .nwes-info {
            text-align: left;
            font-size: 14px;
            font-weight: 400px;
            font-family: "Microsoft YaHei";
            color: #838a9d;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 4;
            -webkit-box-orient: vertical;
            text-align: justify;
            overflow: hidden;
          }
        }
      }
    }
  }
}

/* ====== Mobile responsive overrides for Home page ====== */
@media (max-width: 1200px) {
  .app-container .classification {
    width: 100%;
    max-width: 100%;
    padding: 0 16px;
    flex-wrap: wrap;
    justify-content: center;
    gap: 12px;
  }
  .app-container .openClass .classCard,
  .app-container .course .classCard,
  .app-container .team-box .carouselImage,
  .app-container .works-box,
  .app-container .news-box .nwes-card-box {
    width: 100%;
    max-width: 100%;
    padding-left: 16px;
    padding-right: 16px;
    box-sizing: border-box;
  }
}

@media (max-width: 992px) {
  .app-container .classification {
    margin: 16px auto;
    padding: 8px 12px;
    gap: 10px;

    .course-card .card-content {
      width: calc((100vw - 48px) / 2);
      max-width: 200px;
      height: 72px;
      border-radius: 10px;
    }
  }

  .app-container .openClass,
  .app-container .course,
  .app-container .team-box,
  .app-container .news-box {
    padding: 28px 0;
  }

  .app-container .openClass .title,
  .app-container .course .title,
  .app-container .team-box .title,
  .app-container .works-box .title-box .title,
  .app-container .news-box .nwes-title {
    font-size: 26px;
  }

  .app-container .openClass .classCard,
  .app-container .course .classCard {
    gap: 12px;
    justify-content: space-between;
  }

  .app-container .openClass .classCard .card,
  .app-container .course .classCard .card {
    width: calc(50% - 6px);
    height: auto;
    margin: 0;
  }

  .app-container .openClass .classCard .card img,
  .app-container .course .classCard .card img {
    width: 100%;
    height: auto;
    aspect-ratio: 16 / 10;
    object-fit: cover;
  }

  .app-container .openClass .classCard .card p,
  .app-container .course .classCard .card p {
    width: 100%;
    font-size: 15px;
  }

  .app-container .openClass .classCard .card .headimg,
  .app-container .course .classCard .card .headimg {
    width: 36px !important;
    height: 36px !important;
    border-radius: 50%;
    object-fit: cover;
  }

  .app-container .works-box {
    padding: 32px 16px;
  }

  .app-container .works-box .title-box {
    flex-wrap: wrap;
    gap: 10px;
    font-size: 26px;

    .title {
      margin: 0 12px 0 0;
      width: 100%;
      text-align: left;
    }

    .title-btn {
      margin: 0 8px 0 0;
      font-size: 14px;
    }
  }

  .app-container .works-box .list-box {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    margin-top: 20px;
    justify-content: flex-start;
  }

  .app-container .works-box .list-box .card {
    width: calc(50% - 6px);
  }

  .app-container .works-box .list-box .card img {
    width: 100%;
    height: auto;
    aspect-ratio: 16 / 9;
    object-fit: cover;
  }

  .app-container .news-box .nwes-card-box {
    gap: 12px;
  }

  .app-container .news-box .nwes-card-box .nwes-card {
    width: calc(50% - 6px);
    height: auto;
  }

  .app-container .news-box .nwes-card-box .nwes-card img {
    width: 100%;
    height: auto;
    aspect-ratio: 16 / 10;
    object-fit: cover;
  }

  /* 师资保持横滑，避免破坏无缝滚动 */
  .app-container .team-box .p {
    padding: 0 16px;
    font-size: 14px;
    line-height: 1.6;
  }

  .app-container .team-box .carouselImage {
    border: none;
    padding: 0;
  }

  .app-container .team-box .carouselImage ul.ul-item .li-item {
    width: 180px;
    height: 250px;
    margin-right: 12px;
  }

  .app-container .team-box .carouselImage ul.ul-item .li-item img {
    width: 180px;
    height: 250px;
    object-fit: cover;
  }

  .app-container .team-box .carouselImage ul.ul-item .li-item .info {
    height: 64px;

    .name {
      font-size: 16px;
    }

    .introduce {
      font-size: 12px;
    }
  }
}

@media (max-width: 600px) {
  .app-container .classification .course-card .card-content {
    width: calc((100vw - 40px) / 2);
    max-width: none;
    height: 64px;
  }

  .app-container .openClass .title,
  .app-container .course .title,
  .app-container .team-box .title,
  .app-container .works-box .title-box,
  .app-container .news-box .nwes-title {
    font-size: 22px;
  }

  .app-container .openClass .classCard .card,
  .app-container .course .classCard .card,
  .app-container .works-box .list-box .card,
  .app-container .news-box .nwes-card-box .nwes-card {
    width: 100%;
  }

  .app-container .openClass .classCard .card > div[style*="padding"],
  .app-container .course .classCard .card > div[style*="padding"] {
    padding: 14px !important;
  }

  .app-container .team-box .carouselImage ul.ul-item .li-item {
    width: 150px;
    height: 210px;
  }

  .app-container .team-box .carouselImage ul.ul-item .li-item img {
    width: 150px;
    height: 210px;
  }

  .app-container .openClass .more,
  .app-container .course .more {
    width: 80%;
    height: 48px;
  }
}
</style>

